<template>
  <ul class="mt-1.5 space-y-0.5 text-xs">
    <li
      v-for="rule in PASSWORD_RULES"
      :key="rule.key"
      class="flex items-center gap-1.5"
      :class="rule.test(password) ? 'text-success-600 dark:text-success-400' : 'text-gray-400 dark:text-zinc-500'"
    >
      <svg v-if="rule.test(password)" class="h-3.5 w-3.5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
      </svg>
      <svg v-else class="h-3.5 w-3.5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
        <circle cx="10" cy="10" r="3" />
      </svg>
      {{ rule.label }}
    </li>
  </ul>
</template>

<script setup>
import { PASSWORD_RULES } from '../../utils/passwordPolicy'

defineProps({
  password: { type: String, default: '' },
})
</script>
